import httpClient from './httpClient';
import { DashboardMetricsResponse } from '../types/dashboard';

export interface DashboardQueryParams {
  start?: string;
  end?: string;
  grain?: 'quarter';
  sectionId?: string;
}

export const dashboardApi = {
  getDashboardMetrics: async (
    groupId: string,
    params: DashboardQueryParams = {}
  ): Promise<DashboardMetricsResponse> => {
    const response = await httpClient.get(`/v1/dashboard/${encodeURIComponent(groupId)}/metrics`, {
      params,
    });
    return response.data;
  },
};
